import React from "react";

interface LoadingProps {
  data?: {};
}

const ProductAndServicesLoader: React.FC<LoadingProps> = ({ data }) => {
  return (
    <div className="rounded-lg bg-white py-3 lg:py-6 w-full">
      <div className="flex justify-between items-center animate-pulse px-3 md:px-6">
        <span className="h-6 bg-[#E6EEF5] inline-block w-[30%] rounded-md"></span>
      </div>
      <hr className="border border-[#EAECF0] w-full mt-3 mb-2" />

      <div className="mt-3 px-3 md:px-6 animate-pulse flex flex-col justify-between">
        {[1, 2, 3, 4, 5].map((i) => (
          <div className="mb-3" key={i}>
            <div className="flex justify-between w-full items-center py-2 cursor-pointer">
              <div className="flex items-center gap-2">
                <div className="flex flex-col animate-pulse px-3 md:px-6 w-full">
                  <span className="h-5 bg-[#E6EEF5] mb-1 inline-block w-40 rounded-md"></span>
                  <span className="h-5 bg-[#E6EEF5] mb-1 inline-block w-20 rounded-md"></span>
                </div>
              </div>

              <div className="flex flex-col animate-pulse px-3 md:px-6 w-full justify-end items-end">
                <span className="h-5 bg-[#E6EEF5] mb-1 inline-block w-40 rounded-md"></span>
                <span className="h-5 bg-[#E6EEF5] mb-1 inline-block w-20 rounded-md"></span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProductAndServicesLoader;
